import React from 'react';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

const PageHeader = ({ title, description, icon: Icon, status, badge, actions, className }) => (
  <header className={cn('page-header', className)}>
    <div className="page-header__content">
      <div className="page-header__identity">
        {Icon && <span className="page-header__icon" aria-hidden="true"><Icon /></span>}
        <div>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
      </div>
    </div>
    <div className="page-header__aside">
      {(status || badge) && <Badge variant="info">{status || badge}</Badge>}
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  </header>
);

export default PageHeader;
